
  if (!customElements.get('lg-cart-page')) {
    customElements.define('lg-cart-page', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;

        this.busy = false;
        this.events = new AbortController();

        var options = { signal: this.events.signal };

        this.addEventListener('click', (event) => {
          if (this.busy && event.target.closest('[data-live-cart-form]')) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }

          var control = event.target.closest(
            '[data-cart-step], [data-cart-remove]'
          );

          if (
            !control ||
            event.ctrlKey ||
            event.metaKey ||
            event.shiftKey ||
            event.altKey
          ) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();

          var row = control.closest('[data-cart-key]');
          var input = row.querySelector('[data-live-cart-qty]');

          var quantity = control.hasAttribute('data-cart-remove')
            ? 0
            : Math.max(
                0,
                Number(input.value) + Number(control.dataset.cartStep)
              );

          this.change(row, quantity, control);
        }, {
          signal: this.events.signal,
          capture: true
        });

        this.addEventListener('change', (event) => {
          if (!event.target.matches('[data-live-cart-qty]')) return;

          this.change(
            event.target.closest('[data-cart-key]'),
            Number(event.target.value),
            event.target
          );
        }, options);

        this.addEventListener('keydown', (event) => {
          if (
            event.key !== 'Enter' ||
            !event.target.matches('[data-live-cart-qty]')
          ) {
            return;
          }

          event.preventDefault();

          this.change(
            event.target.closest('[data-cart-key]'),
            Number(event.target.value),
            event.target
          );
        }, options);

        this.addEventListener('submit', (event) => {
          if (this.busy) event.preventDefault();
        }, options);
      }

      disconnectedCallback() {
        if (this.events) this.events.abort();
        this.events = null;
      }

      status(message, error) {
        var status = this.querySelector('[data-cart-status]');
        status.textContent = message;
        status.toggleAttribute('data-error', Boolean(error));
      }

      setBusy(busy) {
        this.busy = busy;

        var form = this.querySelector('[data-live-cart-form]');
        var fieldset = this.querySelector('[data-cart-fieldset]');
        var express = this.querySelector('[data-cart-express]');

        if (form) form.setAttribute('aria-busy', String(busy));
        if (fieldset) fieldset.disabled = busy;
        if (express) express.inert = busy;

        if (!busy) {
          this.querySelectorAll('[data-updating]').forEach((row) => {
            row.removeAttribute('data-updating');
          });
        }
      }

      render(html) {
        if (typeof html !== 'string' || !html) {
          throw new Error(
            'Não foi possível atualizar a visualização da sacola.'
          );
        }

        var page = new DOMParser().parseFromString(html, 'text/html');
        var next = page.querySelector('[data-cart-content]');

        if (!next) {
          throw new Error(
            'Não foi possível atualizar a visualização da sacola.'
          );
        }

        var content = this.querySelector('[data-cart-content]');
        var note = content.querySelector('[name="note"]');
        var coupon = content.querySelector('[data-coupon-input]');
        var noteValue = note ? note.value : null;
        var couponValue = coupon ? coupon.value : null;

        content.replaceWith(next);

        if (noteValue !== null && next.querySelector('[name="note"]')) {
          next.querySelector('[name="note"]').value = noteValue;
        }

        if (
          couponValue !== null &&
          next.querySelector('[data-coupon-input]')
        ) {
          next.querySelector('[data-coupon-input]').value = couponValue;
        }

        var count = Number(next.dataset.count) || 0;

        document.querySelectorAll('[data-cart-count]').forEach((badge) => {
          badge.textContent = count;

          if (badge.classList.contains('lg-cart-count')) {
            badge.hidden = count === 0;
            badge.parentElement.setAttribute(
              'aria-label',
              'Abrir sacola, ' + count + ' itens'
            );
          }
        });

        if (window.LGTheme) window.LGTheme.init(next);

        if (window.Shopify && window.Shopify.PaymentButton) {
          window.Shopify.PaymentButton.init();
        }
      }

      async change(row, quantity, trigger) {
        if (this.busy) return;

        var input = row.querySelector('[data-live-cart-qty]');

        if (
          !Number.isSafeInteger(quantity) ||
          quantity < 0 ||
          input.value.trim() === ''
        ) {
          input.value = input.defaultValue;
          this.status(
            'Informe uma quantidade inteira, igual ou maior que zero.',
            true
          );
          return;
        }

        if (quantity === Number(input.defaultValue)) return;

        var key = row.dataset.cartKey;
        var index = Array.from(
          this.querySelectorAll('[data-cart-key]')
        ).indexOf(row);

        var step = trigger.dataset.cartStep;
        var isInput = trigger.matches('[data-live-cart-qty]');
        var canResume = true;

        this.querySelector('[data-cart-reload]').hidden = true;
        this.setBusy(true);

        row.setAttribute('data-updating', '');
        input.value = quantity;

        this.status(
          quantity === 0 ? 'Removendo item…' : 'Atualizando quantidade…'
        );

        try {
          var response = await fetch(this.dataset.changeUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: key,
              quantity: quantity,
              sections: [this.dataset.sectionId],
              sections_url: this.dataset.cartUrl
            })
          });

          var cart = await response.json();

          if (!response.ok) {
            throw new Error(
              cart.description ||
              cart.message ||
              'Não foi possível alterar a quantidade.'
            );
          }

          if (!this.isConnected) return;

          this.render(
            cart.sections && cart.sections[this.dataset.sectionId]
          );

          this.status(
            quantity === 0
              ? 'Item removido da sacola.'
              : 'Quantidade e totais atualizados.'
          );
        } catch (error) {
          if (!this.isConnected) return;

          this.status('Conferindo o estado da sacola…');

          try {
            var url = new URL(
              this.dataset.cartUrl,
              window.location.origin
            );

            url.searchParams.set('sections', this.dataset.sectionId);

            var recovery = await fetch(url, {
              cache: 'no-store'
            });

            if (!recovery.ok) {
              throw new Error('Falha ao conferir a sacola.');
            }

            var sections = await recovery.json();

            if (!this.isConnected) return;

            this.render(sections[this.dataset.sectionId]);

            this.status(
              error instanceof TypeError || error instanceof SyntaxError
                ? 'A conexão falhou. Confira as quantidades atualizadas antes de tentar novamente.'
                : error.message + ' Confira as quantidades exibidas.',
              true
            );
          } catch (recoveryError) {
            canResume = false;

            this.status(
              'Não foi possível confirmar o estado da sacola. Recarregue antes de continuar.',
              true
            );

            this.querySelector('[data-cart-reload]').hidden = false;
          }
        } finally {
          if (this.isConnected) {
            this.setBusy(!canResume);

            if (
              canResume &&
              (
                document.activeElement === document.body ||
                document.activeElement === trigger
              )
            ) {
              var rows = Array.from(
                this.querySelectorAll('[data-cart-key]')
              );

              var targetRow =
                rows.find((item) => item.dataset.cartKey === key) ||
                rows[Math.min(index, rows.length - 1)];

              var target = targetRow
                ? targetRow.querySelector(
                    isInput
                      ? '[data-live-cart-qty]'
                      : step
                        ? '[data-cart-step="' + step + '"]'
                        : '[data-cart-remove]'
                  )
                : this.querySelector('.cart__empty a');

              if (target) {
                target.focus({ preventScroll: true });
              }
            }
          }
        }
      }
    });
  }

(() => {
  const drawer = document.getElementById('LGCartDrawer');
  if (!drawer || drawer.dataset.ready) return;
  drawer.dataset.ready = 'true';
  const body = drawer.querySelector('[data-lg-body]');
  const status = drawer.querySelector('[data-lg-status]');
  const cartURL = new URL(drawer.dataset.cartUrl, location.origin);
  const normalize = path => path.replace(/\/+$/, '');
  let loading = null;
  let opener = null;
  const notify = message => { status.textContent = message; };
  const updateCount = count => document.querySelectorAll('[data-cart-count]').forEach(badge => {
    badge.textContent = count;
    if (badge.classList.contains('lg-cart-count')) {
      badge.hidden = count === 0;
      badge.parentElement.setAttribute('aria-label', `Abrir sacola, ${count} itens`);
    }
  });
  function show(trigger) {
    if (drawer.open) return;
    opener = trigger || document.activeElement;
    drawer.showModal();
    document.documentElement.classList.add('lg-sacola-open');
    drawer.querySelector('[data-lg-close]').focus();
  }
  drawer.addEventListener('close', () => {
    document.documentElement.classList.remove('lg-sacola-open');
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  });
  drawer.querySelector('[data-lg-close]').addEventListener('click', () => drawer.close());
  drawer.addEventListener('click', event => {
    if (event.target !== drawer) return;
    const bounds = drawer.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) drawer.close();
  });
  async function refresh() {
    if (loading) return loading;
    body.inert = true;
    loading = (async () => {
      const response = await fetch(cartURL.href, { cache: 'no-store', credentials: 'same-origin' });
      if (!response.ok) throw new Error('Não foi possível carregar a sacola. Use “Ver carrinho completo”.');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const page = doc.querySelector('lg-cart-page');
      if (!page) throw new Error('Não foi possível abrir a sacola lateral. Use “Ver carrinho completo”.');
      // Only the cart markup is imported. Scripts from fetched pages are never executed.
      page.querySelectorAll('script').forEach(script => script.remove());
      body.replaceChildren(document.importNode(page, true));
      const title = page.querySelector('.cart__title');
      if (title) drawer.querySelector('#LGCartTitle').textContent = title.textContent.trim();
      updateCount(Number(page.querySelector('[data-cart-content]')?.dataset.count) || 0);
    })();
    try { await loading; } finally { loading = null; body.inert = false; }
  }
  async function open(trigger) {
    if (normalize(location.pathname) === normalize(cartURL.pathname)) {
      location.assign(cartURL.href);
      return;
    }
    show(trigger);
    // Reopening while a cart mutation is in flight must not detach its component.
    if (body.querySelector('lg-cart-page')?.busy) return;
    notify('Carregando sua sacola…');
    try { await refresh(); notify(''); }
    catch (error) { notify(error.message); }
  }
  window.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    const explicit = event.target.closest('[data-lg-cart-open]');
    if (!link && !explicit) return;
    if (event.target.closest('#LGCartDrawer') || link?.hasAttribute('download') || (link?.target && link.target !== '_self')) return;
    const target = link ? new URL(link.href, location.origin) : cartURL;
    if (!explicit && (target.origin !== location.origin || normalize(target.pathname) !== normalize(cartURL.pathname) || target.search)) return;
    // The complete cart page remains usable and has no duplicated component IDs.
    if (normalize(location.pathname) === normalize(cartURL.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(explicit || link);
  }, true);
  // Coupon is carried by the native checkout form; Shopify validates it at checkout.
  drawer.addEventListener('click', event => {
    const button = event.target.closest('[data-coupon-apply]');
    if (!button) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const form = button.closest('form');
    const value = form.querySelector('[data-coupon-input]').value.trim();
    let input = form.querySelector('input[name="discount"]');
    if (!input) {
      input = document.createElement('input'); input.type = 'hidden'; input.name = 'discount'; form.append(input);
    }
    input.value = value;
    notify(value ? 'Cupom informado. A validade e o desconto serão conferidos no checkout.' : 'Informe um cupom.');
  }, true);
  drawer.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('[data-coupon-input]')) {
      event.preventDefault(); event.stopPropagation();
      event.target.closest('[data-coupon]').querySelector('[data-coupon-apply]').click();
    }
  }, true);
  window.LGCartDrawer = { open, isBusy: () => Boolean(loading || body.querySelector('lg-cart-page')?.busy) };
  drawer.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('[data-live-cart-form]')) return;
    const coupon = form.querySelector('[data-coupon-input]');
    if (coupon?.value.trim()) {
      let input = form.querySelector('input[name="discount"]');
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'discount'; form.append(input); }
      input.value = coupon.value.trim();
    }
  }, true);
})();
